import { SleepLogData } from '@app/model/b1.model'
import { storage3Service } from '@app/srv/storage3/storage3.service'
import { BAND_RAW_DATA } from '@app/srv/store.service'
import { distinctUntilDeeplyChanged } from '@app/util/distinctUntilDeeplyChanged'
import { logUtil } from '@app/util/log.util'
import { _objectKeys } from '@naturalcycles/js-lib'
import { AccountId } from '@naturalcycles/shared'
import { Action } from 'redux'
import { Subject } from 'rxjs'
import { debounceTime, mergeMap } from 'rxjs/operators'

// TODO: should it have any info about the device?
// serial number or device name
export interface BandRawDataState {
  [accountId: AccountId]: SleepLogData[]
}

type State = BandRawDataState

const initialState: State = {}

const actions: any = {
  extendBandRawData(state: State, action: { type: string; payload: BandRawDataState }): State {
    const accountIds = _objectKeys(action.payload)

    const newState = {
      ...state,
      ...Object.fromEntries(
        accountIds.map(accountId => [
          accountId,
          [...(state[accountId] || []), ...(action.payload[accountId] || [])],
        ]),
      ),
    }

    persistBandRawDataSubject.next(newState)

    return newState
  },

  clearBandRawData(_state: State): State {
    persistBandRawDataSubject.next({})

    return {}
  },
}

// biome-ignore lint/style/useDefaultParameterLast: ok
export function bandRawDataReducer(state = initialState, action: Action): State {
  if (actions[action.type]) return actions[action.type](state, action)
  return state
}

const persistBandRawDataSubject = new Subject<BandRawDataState | undefined>()

persistBandRawDataSubject
  .pipe(
    debounceTime(1000),
    distinctUntilDeeplyChanged(),
    mergeMap(async bandRawData => {
      await storage3Service.setItem(BAND_RAW_DATA, bandRawData).catch(err => {
        logUtil.log('bandRawData.reducer Error storing bandRawData')
        logUtil.error(err)
      })
    }, 1),
  )
  .subscribe()
